import axios from '../../helpers/axios';
import {
  FETCH_STAKEHOLDERS_START,
  FETCH_STAKEHOLDERS_ERROR,
  FETCH_STAKEHOLDERS_SUCCESS,
  EDIT_STAKEHOLDERS_START,
  EDIT_STAKEHOLDERS_SUCCESS,
  EDIT_STAKEHOLDERS_ERROR,
  CREATE_STAKEHOLDERS_START,
  CREATE_STAKEHOLDERS_SUCCESS,
  CREATE_STAKEHOLDERS_ERROR,
  RESET_STAKEHOLDERS_ERRORS,
} from './types';
import { enqueueSnackbar } from './notificationActions';
import { t13s } from '../../translationKeys';
import { resetDocumentsVerify } from './documentsActions';

const entityName = 'stakeholder';
export const fetchStakeholders = businessId => dispatch => {
  dispatch({ type: FETCH_STAKEHOLDERS_START });
  dispatch(resetDocumentsVerify(entityName));
  axios
    .get(`/api/business/${businessId}/stakeholder`)
    .then(res => {
      const stakeholders = res.data;
      dispatch({
        type: FETCH_STAKEHOLDERS_SUCCESS,
        payload: { stakeholders },
      });
    })
    .catch(error => {
      const errorCode = error?.response?.data?.errorCode;
      dispatch({ type: FETCH_STAKEHOLDERS_ERROR, payload: { errorCode } });
      dispatch(
        enqueueSnackbar({
          message: t13s.NOTIFICATION.FETCH_STAKEHOLDERS_ERROR,
          options: {
            variant: 'error',
          },
        })
      );
    });
};

export const editStakeholders = stakeholder => dispatch => {
  const { businessId, stakeholderId, ...rest } = stakeholder;
  dispatch({ type: EDIT_STAKEHOLDERS_START });
  axios
    .put(`/api/business/${businessId}/stakeholder/${stakeholderId}`, {
      ...rest,
    })
    .then(res => {
      dispatch({
        type: EDIT_STAKEHOLDERS_SUCCESS,
        payload: { updatedStakeholder: res.data },
      });
      dispatch(
        enqueueSnackbar({
          message: t13s.NOTIFICATION.EDIT_STAKEHOLDERS_SUCCESS,
          options: {
            variant: 'success',
          },
        })
      );
    })
    .catch(error => {
      const errorCode = error?.response?.data?.errorCode;
      dispatch({ type: EDIT_STAKEHOLDERS_ERROR, payload: { errorCode } });
    });
};

export const createStakeholder = (businessId, stakeholder) => dispatch => {
  dispatch({ type: CREATE_STAKEHOLDERS_START });
  axios
    .post(`/api/business/${businessId}/stakeholder`, stakeholder)
    .then(res => {
      dispatch({
        type: CREATE_STAKEHOLDERS_SUCCESS,
        payload: { stakeholder: res.data },
      });
      dispatch(
        enqueueSnackbar({
          message: t13s.NOTIFICATION.CREATE_STAKEHOLDERS_SUCCESS,
          options: {
            variant: 'success',
          },
        })
      );
    })
    .catch(error => {
      const errorCode = error?.response?.data?.errorCode;
      dispatch({ type: CREATE_STAKEHOLDERS_ERROR, payload: { errorCode } });
    });
};

export const resetStakeholdersErrors = () => dispatch => {
  dispatch({ type: RESET_STAKEHOLDERS_ERRORS });
};
